import React, { useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { useSelector, useDispatch } from "react-redux";
import {
  styled,
  Typography,
  Container,
  FormControl,
  Autocomplete,
  TextField,
  Tabs,
  Tab,
} from "@mui/material";
import { getUserProfile } from "../../../../actions/user";
import DropSitePin from "./dropSitePin";

const StyledRoot = styled("div")(({ theme }) => ({
  paddingInline: "8vw",
  [theme.breakpoints.down("sm")]: {
    paddingInline: "0",
    width: "100%",
  },
  "& .page": {
    paddingBottom: "36px",
  },
  "& .Title": {
    textAlign: "center",
    fontSize: "25px",
  },
}));

const TabsStyled = styled(Tabs)({
  "& .MuiTab-root": {
    marginTop: "24px",
    fontSize: "16px",
    fontWeight: "500",
    minWidth: "150px",
    minHeight: "60px",
  },
});

const TabStyled = styled(Tab)({
  fontSize: "14px",
  height: "60px",
});

const HeaderOfDiv = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "start",
  marginBlock: "20px",
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
  },
}));

const SettingPage = ({ history }) => {
  const dispatch = useDispatch();
  const { user: currentUser } = useSelector((state) => state.auth);
  const { result: userProfile } = useSelector((state) => state.userProfile);

  const [currentTabPath, setCurrentTabPath] = useState("drop_site_pin");
  const { control } = useForm();

  useEffect(() => {
    if (!userProfile && currentUser?.idUser) {
      dispatch(getUserProfile(currentUser.idUser));
    }
  }, [dispatch, userProfile, currentUser]);

  const handleTabChange = (_, path) => {
    setCurrentTabPath(path);
    history.push(`/admin/setting/${path}`);
  };

  return (
    <Container maxWidth="xl">
      <StyledRoot>
        <div className="page">
          <HeaderOfDiv>
            <Typography variant="h4">ข้อมูลระบบ</Typography>
          </HeaderOfDiv>

          {userProfile && (
            <FormControl fullWidth variant="outlined">
              <Controller
                name="company"
                control={control}
                defaultValue={userProfile.nameShort}
                render={({ field }) => (
                  <Autocomplete
                    {...field}
                    options={["บริษัท " + userProfile.nameShort]}
                    getOptionLabel={(option) => option}
                    isOptionEqualToValue={(option, value) => option === value}
                    value={"บริษัท " + userProfile.nameShort || ""}
                    disableClearable
                    renderInput={(params) => (
                      <TextField {...params} variant="outlined" />
                    )}
                    sx={{
                      backgroundColor: "white",
                      borderRadius: "8px",
                      "& fieldset": { border: "none" },
                    }}
                  />
                )}
              />
            </FormControl>
          )}

          <TabsStyled
            value={currentTabPath}
            onChange={handleTabChange}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
          >
            <TabStyled id="Tab-dropSitePin" value="drop_site_pin" label="ข้อมูล SITE" />
          </TabsStyled>

          {userProfile?.idCompany && (
            <DropSitePin
              selectedCompanyId={userProfile.idCompany}
              selectedCompany={userProfile.nameShort}
            />
          )}
        </div>
      </StyledRoot>
    </Container>
  );
};

export default SettingPage;